import { convertQueryCommandToQueryString, IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  ITourNylasCalendars,
} from '@llws/lift-entity-interfaces';
import {
  IApiResponse,
  IMetaResponse,
} from '@/shared';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { adminRequest } from '@/shared/request-configs/admin-request';

interface IToursState {
  enabledNylasCalendars: Array<ITourNylasCalendars>,
  availableNylasCalendars: Array<ITourNylasCalendars>,
}

// Base store configuration
const agentGatewayResourcePathAgent: string = '/tour-api-agent';
const adminGatewayResourcePathAdmin: string = '/tour-api-admin';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<ITourNylasCalendars>({
  adminGatewayResourcePath: adminGatewayResourcePathAdmin,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
    enabledNylasCalendars: [] as Array<ITourNylasCalendars>,
    availableNylasCalendars: [] as Array<ITourNylasCalendars>,

  },

  getters: {
    ...base.getters,
    enabledNylasCalendars(state: IToursState) {
      return state.enabledNylasCalendars.filter((data) => data.calendarName !== 'Emailed events');
    },
    availableNylasCalendars(state: IToursState) {
      return state.availableNylasCalendars.filter((data) => data.calendarName !== 'Emailed events');
    },
  },

  mutations: {
    ...base.mutations,

    setUserEnabledNylasCalendars(state: IToursState, payload: IApiResponse<ITourNylasCalendars[], IMetaResponse>) {
      state.availableNylasCalendars = payload.data || [];
      const enabledCalendars = payload.data?.filter((data) => data.status === 'enabled');
      state.enabledNylasCalendars = enabledCalendars || [];
    },

  },

  actions: {
    ...base.actions,

    getTourNylasCalendars: async (ctx: IAction<IStateStrict<ITourNylasCalendars>>, payload: IQueryCommandOptions) => {
      const response = await adminRequest.get(`${agentGatewayResourcePathAgent}/tour_nylas_calendars${convertQueryCommandToQueryString(payload)}`);
      ctx.commit('setUserEnabledNylasCalendars', response);
    },
    getAdminTourNylasCalendars: async (ctx: IAction<IStateStrict<ITourNylasCalendars>>, payload: IQueryCommandOptions) => {
      const response = await adminRequest.get(`${adminGatewayResourcePathAdmin}/tour_nylas_calendars${convertQueryCommandToQueryString(payload)}`);
      ctx.commit('setUserEnabledNylasCalendars', response);
    },
    updateTourNylasCalendar: async (
      _ctx: IAction<IStateStrict<ITourNylasCalendars>>,
      payload: ITourNylasCalendars,
    ) => {
      const response = await adminRequest.put(`${agentGatewayResourcePathAgent}/tour_nylas_calendars/${payload.id}`, payload);
      return response;
    },
    refreshNylasCalendar: async (_ctx: IAction<IStateStrict<ITourNylasCalendars>>) => {
      const response = await adminRequest.get(`${agentGatewayResourcePathAgent}/nylas/v3/refreshCal`);
      return response?.data;
    },
    syncNylasCalendar: async (_ctx: IAction<IStateStrict<ITourNylasCalendars>>) => {
      const response = await adminRequest.get(`${agentGatewayResourcePathAgent}/nylas/v3/sync`);

      return response?.data;
    },

  },
};
